class TableGridValidationCellController {
  constructor() {
    this.name = 'tableGridValidationCell';
  }

  getValidationValue(row,validation){
    let value = validation.value(row);
    return value;
  }

  getValidationClass(validation){  	
    return validation.class;
  }
}

export default TableGridValidationCellController;



// WEBPACK FOOTER //
// ./app/components/tableGridValidationCell/tableGridValidationCell.controller.js